<template>
	<div>
		<div class="subheader position-relative">
			<h1 class="text-center text-white position-relative">
				{{ $t("booking.title") }}
			</h1>
		</div>
	    <div class="bg-vanilla text-brown">
			<div class="container p-md-5 py-3">
				<div class="row">
					<div class="col-12">
						<iframe id="salonicBookingWidget" src="https://csodaszarvas-ijaszbarlang.salonic.hu/?iframe=true" style="width: 100%; max-width: 1980px; height: 500px; border: 1px solid #eee; border-radius: 4px"></iframe>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { Bus }  from "../bus.js";

    export default {
    	data: function(){
    		return {
    			lang: ""
    		}
    	},
    	created: function(){
    		this.lang = this.$i18n.locale;
    	},
    	mounted: function(){
    		var self = this;
    		Bus.$on("lang", (lang) => {
				if(lang === "hu"){
					self.lang = "hu";
				}else{
					self.lang = "en";
				}
			});
    	},
    	watch: {
    		lang: function(){
    			if(this.lang === "hu"){
					history.pushState('', "Pályafoglalás", "https://ijaszat.eu/palyafoglalas");
				}else{
					history.pushState('', "Booking", "https://ijaszat.eu/booking");
				}
    		}
    	},
    	metaInfo() {
		    return {
				titleTemplate: chunk => (
					this.lang === 'hu'
                    ? 'Csodaszarvas Íjászbarlang - Pályafoglalás'
                    : 'Csodaszarvas Íjászbarlang - Booking'
				),
				meta: [
    			{
    				vmid: 'description',
			        name: 'description',
			        content: this.lang === 'hu' ? 'Foglald le íjászpályádat még ma online felületünkön.' : 'Book your archery spot today!',
    			},
    			{
    				vmid: 'og:description',
			        name: 'og:description',
			        content: this.lang === 'hu' ? 'Foglald le íjászpályádat még ma online felületünkön.' : 'Book your archery spot today!',
    			},
    			{
    				vmid: 'og:title',
    				property: 'og:title',
        			content: this.lang === 'hu' ? 'Csodaszarvas Íjászbarlang - Pályafoglalás' : 'Csodaszarvas Íjászbarlang - Book your spot',
    			}
    		]
			};
		}
    };
</script>


// WEBPACK FOOTER //
// src/components/Booking.vue